import { useEffect } from 'react';

import { showContinueAs } from '../../services/schibstedAccount';

import { setLastShown, shouldShowPopup } from './helpers';

async function showPopup() {
  const shouldBeShown = await shouldShowPopup();

  if (shouldBeShown) {
    try {
      await showContinueAs();

      setLastShown(Date.now());
    } catch {}
  }
}

function ContinueAsPopup() {
  useEffect(() => {
    showPopup();
  }, []);

  return null;
}

export { ContinueAsPopup };
